import { ConfigurationSettings } from "models/configuration-settings";
import { clients } from "lib/https";

export const contactSales = async (
    data: any,
    config: ConfigurationSettings
) => {

    const baseUrl = `https://${config.paths.baseUrl}`;
    const url = `${baseUrl}${config.paths.bebrave.contactSales}`;

    const payload = {
        ...data,
        ProjectKey: config.blocksKey,
    };

    return clients.post(url, config.blocksKey, JSON.stringify(payload));
};